/* mixin methods for auto-applying model keys as tag attributes */
/* views with these methods can define an array called `attribute_keys` */

const _ = require('lib/underscore')

const InputAttributes = {

    setAttributes() {
        const attributes = _.result(this, 'attributes')
        this.$el.attr(attributes)
    },

    attributes() {
        return this.model.pick(this.attribute_keys)
    },
}

module.exports = InputAttributes
